<script setup lang="ts">
import type { MessageProps } from 'primevue/message'
type Props = {
  severity: MessageProps['severity']
  message: string
  command?: () => void
}

defineProps<Props>()
</script>

<template>
  <PvMessage :severity>
    <div
      class="flex flex-col justify-center items-center text-center min-h-[7rem] w-full p-4"
      :class="{ 'gap-2': command }"
    >
      <div v-if="!command">
        <span class="icon-[ph--info-bold] text-2xl" />
      </div>
      <div class="text-xs leading-tight">
        {{ message }}
      </div>
      <PvButton
        v-if="command"
        severity="contrast"
        outlined
        class="w-full"
        size="small"
        @click="command()"
      >
        <span class="icon-[ph--arrow-counter-clockwise-bold]" />
        Reintentar
      </PvButton>
    </div>
  </PvMessage>
</template>
